export enum EUsageDataFrom {
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  MANUAL_SCHEDULE = "MANUAL_SCHEDULE",
  SEMI_AUTOMATED_SCHEDULE = "SEMI_AUTOMATED_SCHEDULE",
  TELEMETRY = "TELEMETRY",
  PLC = "PLC",
}
